<app-rings-loader *ngIf="isLoading"></app-rings-loader>
<div class="modal-header">
    <h3 class="dialog-title text-center">{{ title }}</h3>
</div>
<div mat-dialog-content>
    <div class="modal-content">
        <div class="logo-img-container">
            <img src="assets/images/grpLogo.svg" alt="" class="logo-img" />
        </div>
        <app-progress-spinner [show]="isFormLoading"></app-progress-spinner>
        <div class="modal-body">
            <div>
                <div class="form-fields-body">
                    <div class="row">
                        <div
                            *ngFor="let field of fields; trackBy: trackByIndex"
                            [ngClass]="
                                field.visible
                                    ? field.columnSpanClass
                                    : ''
                            "
                        >
                            <mat-form-field
                                *ngIf="
                                    field.type === FormFieldType.Text &&
                                    field.visible
                                "
                                [class]="field.cssClass"
                            >
                                <mat-label class="field-label"
                                    >{{ field.name | translate }}
                                    <i
                                        *ngIf="field.tooltip"
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                        [matTooltip]="field.tooltip"
                                        matTooltipPosition="right"
                                    ></i>
                                </mat-label>
                                <input
                                    matInput
                                    [(ngModel)]="entity[field.property]"
                                    [required]="field.required"
                                    [placeholder]="field.tooltip"
                                    [readonly]="field.readonly"
                                    [class.cursor-not-allowed]="field.readonly"
                                    (change)="field.onChange($event, field); updateFieldVisibility()"
                                />
                                <mat-error
                                    >{{ field.name | translate }}
                                    {{ "is required" | translate }}</mat-error
                                >
                            </mat-form-field>

                            <mat-form-field
                                appearance="outline"
                                *ngIf="
                                    field.type === FormFieldType.TextArea &&
                                    field.visible
                                "
                            >
                                <mat-label class="field-label"
                                    >{{ field.name | translate }}
                                    <i
                                        *ngIf="field.tooltip"
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                        [matTooltip]="field.tooltip"
                                        matTooltipPosition="right"
                                    ></i>
                                </mat-label>
                                <textarea
                                    matInput
                                    [(ngModel)]="entity[field.property]"
                                    [placeholder]="field.tooltip"
                                    [required]="field.required"
                                    [readonly]="field.readonly"
                                    [class.cursor-not-allowed]="field.readonly"
                                    (ngModelChange)="field.onChange($event, field); updateFieldVisibility()"
                                ></textarea>
                                <mat-error
                                    >{{ field.name | translate }}
                                    {{ "is required" | translate }}</mat-error
                                >
                            </mat-form-field>

                            <mat-form-field
                                [class]="field.cssClass"
                                *ngIf="
                                    (field.type ===
                                        FormFieldType.SingleSelection ||
                                        field.type ===
                                            FormFieldType.MultipleSelection ||
                                        field.type ===
                                            FormFieldType.HierarchicalSelection) &&
                                    field.visible
                                "
                                [class.search-extended]="field.searchComponent"
                            >
                                <mat-label class="field-label"
                                    >{{ field.name | translate }}
                                    <i
                                        *ngIf="field.tooltip"
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                        [matTooltip]="field.tooltip"
                                        matTooltipPosition="right"
                                    ></i>
                                </mat-label>
                                <mat-select
                                    (selectionChange)="
                                        field.onChange($event, field); updateFieldVisibility()
                                    "
                                    [placeholder]="field.tooltip"
                                    [(ngModel)]="entity[field.property]"
                                    [required]="field.required"
                                    [disabled]="$safeNavigationMigration(field?.readonly)"
                                    [class.cursor-not-allowed]="field.readonly"
                                    [multiple]="
                                        field.type ===
                                            FormFieldType.MultipleSelection ||
                                        (field.type ===
                                            FormFieldType.HierarchicalSelection &&
                                            field.multiple)
                                    "
                                    [panelClass]="
                                        field.type ===
                                        FormFieldType.HierarchicalSelection
                                            ? 'hierarchical-select-panel'
                                            : field.optionTemplate ||
                                                field.optionTemplateFields
                                                    ?.length
                                              ? 'multiple-select-panel'
                                              : ''
                                    "
                                >
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [(ngModel)]="
                                                entity[field.searchProperty]
                                            "
                                            placeholderLabel="{{
                                                'Search' | translate
                                            }}..."
                                            (ngModelChange)="
                                                field.onSearchChange(
                                                    $event,
                                                    field
                                                )
                                            "
                                        >
                                        </ngx-mat-select-search>
                                    </mat-option>

                                    <mat-option
                                        disabled
                                        *ngIf="
                                            field.type ===
                                                FormFieldType.HierarchicalSelection &&
                                            (
                                                field.options
                                                | filter
                                                    : entity[
                                                          field.searchProperty
                                                      ]
                                                    : field.searchKeys
                                            ).length === 0
                                        "
                                    >
                                        {{ "No options found" | translate }}
                                    </mat-option>

                                    <ng-container
                                        *ngIf="
                                            field.type ===
                                            FormFieldType.HierarchicalSelection
                                        "
                                    >
                                        <ng-container
                                            *ngTemplateOutlet="
                                                renderTree;
                                                context: {
                                                    nodes:
                                                        field.options
                                                        | filter
                                                            : entity[
                                                                  field
                                                                      .searchProperty
                                                              ]
                                                            : field.searchKeys,
                                                    level: 0,
                                                }
                                            "
                                        ></ng-container>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="
                                            field.type !==
                                            FormFieldType.HierarchicalSelection
                                        "
                                    >
                                        <ng-container
                                            *ngIf="
                                                field.groups &&
                                                    field.groups.length > 0;
                                                else noGroups
                                            "
                                        >
                                            <mat-optgroup
                                                *ngFor="
                                                    let group of field.groups;
                                                    trackBy: trackByIndex
                                                "
                                                [label]="group.groupName"
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let option of group.items
                                                            | filter
                                                                : entity[
                                                                      field
                                                                          .searchProperty
                                                                  ];
                                                        trackBy: trackByEntityId
                                                    "
                                                    [value]="option.id"
                                                >
                                                    {{
                                                        option.name | translate
                                                    }}
                                                </mat-option>
                                                <mat-option
                                                    *ngIf="
                                                        (
                                                            group.items
                                                            | filter
                                                                : entity[
                                                                      field
                                                                          .searchProperty
                                                                  ]
                                                        ).length === 0
                                                    "
                                                    disabled
                                                >
                                                    {{
                                                        "No options found"
                                                            | translate
                                                    }}
                                                </mat-option>
                                            </mat-optgroup>
                                        </ng-container>
                                    </ng-container>

                                    <mat-select-trigger
                                        *ngIf="field.selectionTemplate"
                                    >
                                        <span
                                            [innerHTML]="
                                                field.selectionTemplate(field)
                                                    | safeHtml
                                            "
                                        ></span>
                                    </mat-select-trigger>

                                    <ng-template #noGroups>
                                        <mat-option
                                            *ngIf="
                                                field.optionTemplate &&
                                                !field.optionTemplateFields
                                                    ?.length &&
                                                field.options.length
                                            "
                                            disabled
                                            class="static-option-header"
                                        >
                                            <div
                                                class="select-option header"
                                                [innerHTML]="
                                                    field.optionTemplate(
                                                        field.options[0],
                                                        true
                                                    ) | safeHtml
                                                "
                                            ></div>
                                        </mat-option>
                                        <mat-option
                                            *ngIf="
                                                field.optionTemplateFields
                                                    ?.length &&
                                                field.options.length
                                            "
                                            disabled
                                            class="static-option-header"
                                        >
                                            <app-option-row
                                                [option]="field.options[0]"
                                                [fields]="
                                                    field.optionTemplateFields
                                                "
                                                [isHeader]="true"
                                                [labelMap]="
                                                    field.optionTemplateLabelMap
                                                "
                                                [badgeFields]="
                                                    field.optionTemplateBadgeFields
                                                "
                                            >
                                            </app-option-row>
                                        </mat-option>

                                        <ng-container
                                            *ngIf="
                                                field.type !==
                                                FormFieldType.HierarchicalSelection
                                            "
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let option of field.options
                                                        | filter
                                                            : entity[
                                                                  field
                                                                      .searchProperty
                                                              ]
                                                            : field.searchKeys;
                                                    trackBy: trackByEntityId
                                                "
                                                [value]="option.id"
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        field.optionTemplate;
                                                        else checkNewTemplate
                                                    "
                                                >
                                                    <div
                                                        class="select-option"
                                                        [innerHTML]="
                                                            field.optionTemplate(
                                                                option,
                                                                false
                                                            ) | safeHtml
                                                        "
                                                    ></div>
                                                </ng-container>
                                                <ng-template #checkNewTemplate>
                                                    <ng-container
                                                        *ngIf="
                                                            field
                                                                .optionTemplateFields
                                                                ?.length;
                                                            else defaultOption
                                                        "
                                                    >
                                                        <app-option-row
                                                            [option]="option"
                                                            [fields]="
                                                                field.optionTemplateFields
                                                            "
                                                            [isHeader]="false"
                                                            [labelMap]="
                                                                field.optionTemplateLabelMap
                                                            "
                                                            [badgeFields]="
                                                                field.optionTemplateBadgeFields
                                                            "
                                                        >
                                                        </app-option-row>
                                                    </ng-container>
                                                </ng-template>
                                                <ng-template #defaultOption>
                                                    {{
                                                        option.name | translate
                                                    }}
                                                </ng-template>
                                            </mat-option>
                                        </ng-container>

                                        <mat-option
                                            *ngIf="
                                                (
                                                    field.options
                                                    | filter
                                                        : entity[
                                                              field
                                                                  .searchProperty
                                                          ]
                                                        : field.searchKeys
                                                ).length === 0 &&
                                                field.type !==
                                                    FormFieldType.HierarchicalSelection
                                            "
                                            disabled
                                        >
                                            {{ "No options found" | translate }}
                                        </mat-option>
                                    </ng-template>

                                    <ng-template
                                        #renderTree
                                        let-nodes="nodes"
                                        let-level="level"
                                    >
                                        <ng-container
                                            *ngFor="let node of nodes; trackBy: trackByEntityId"
                                        >
                                            <mat-option
                                                [value]="node.id"
                                                [ngClass]="'mat-level-' + level"
                                            >
                                                <ng-container
                                                    *ngFor="
                                                        let i of [].constructor(
                                                            level
                                                        );
                                                        let idx = index;
                                                        trackBy: trackByIndex
                                                    "
                                                >
                                                    <div
                                                        class="pre-option-line"
                                                        [ngClass]="
                                                            'pre-option-level-' +
                                                            idx
                                                        "
                                                    ></div>
                                                </ng-container>
                                                {{ node.name }}
                                            </mat-option>
                                            <ng-container
                                                *ngIf="
                                                    node.children &&
                                                    node.children.length > 0
                                                "
                                            >
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        renderTree;
                                                        context: {
                                                            nodes: node.children,
                                                            level: level + 1,
                                                        }
                                                    "
                                                ></ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-template>
                                </mat-select>

                                <button
                                    class="selection-close-btn"
                                    *ngIf="
                                        entity[field.property] !== null &&
                                        entity[field.property] !== undefined &&
                                        field.type ===
                                            FormFieldType.SingleSelection &&
                                        !field?.readonly
                                    "
                                    mat-icon-button
                                    matSuffix
                                    tabindex="-1"
                                    (click)="
                                        clearSelect(field);
                                        $event.stopPropagation()
                                    "
                                    [attr.aria-label]="
                                        'Clear selection' | translate
                                    "
                                >
                                    <mat-icon>close</mat-icon>
                                </button>

                                <mat-error
                                    *ngIf="
                                        field.required &&
                                        (field.type ===
                                            FormFieldType.MultipleSelection ||
                                        (field.type ===
                                            FormFieldType.HierarchicalSelection &&
                                            field.multiple)
                                            ? !entity[field.property]?.length
                                            : !entity[field.property])
                                    "
                                >
                                    {{ field.name | translate }}
                                    {{ "is required" | translate }}
                                </mat-error>
                            </mat-form-field>

                            <div
                                *ngIf="
                                    field.searchComponent &&
                                    field.visible
                                "
                                class="extended-search-icon"
                            >
                                <span
                                    class="material-symbols-outlined"
                                    (click)="openSearchDialog(field)"
                                    >search</span
                                >
                            </div>

                            <div
                                class="padding-y-10"
                                *ngIf="
                                    field.type === FormFieldType.Checkbox &&
                                    field.visible
                                "
                            >
                                <mat-checkbox
                                    color="primary"
                                    [(ngModel)]="entity[field.property]"
                                    (change)="field.onChange($event); updateFieldVisibility()"
                                >
                                    {{ field.name | translate }}
                                </mat-checkbox>
                            </div>

                            <div
                                class="padding-y-10"
                                *ngIf="
                                    field.type === FormFieldType.Radio &&
                                    field.visible
                                "
                                [class]="field.cssClass"
                            >
                                <label class="field-label block mb-2"
                                    >{{ field.name | translate }}
                                    <i
                                        *ngIf="field.tooltip"
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                        [matTooltip]="field.tooltip"
                                        matTooltipPosition="right"
                                    ></i>
                                </label>
                                <mat-radio-group
                                    [(ngModel)]="entity[field.property]"
                                >
                                    <mat-radio-button
                                        *ngFor="let option of field.options; trackBy: trackByEntityId"
                                        [value]="option.id"
                                        (change)="field.onChange(option.id); updateFieldVisibility()"
                                    >
                                        {{ option.name | translate }}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>

                            <div
                                class="padding-y-10"
                                *ngIf="
                                    field.type === FormFieldType.Label &&
                                    field.visible
                                "
                                [class]="field.cssClass"
                                (click)="field.onClick(entity[field.property])"
                            >
                                <span *ngIf="field.iconClass">
                                    <i
                                        [ngClass]="field.iconClass"
                                        class="icon"
                                    ></i>
                                </span>
                                <mat-label class="mr-3 field-label"
                                    >{{ field.name | translate }}
                                    <i
                                        *ngIf="field.tooltip"
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                        [matTooltip]="field.tooltip"
                                        matTooltipPosition="right"
                                    ></i>
                                </mat-label>
                            </div>

                            <div
                                class="padding-y-10"
                                [class]="field.cssClass"
                                *ngIf="
                                    field.type === FormFieldType.Toggle &&
                                    field.visible
                                "
                            >
                                <mat-label class="mr-3 field-label"
                                    >{{ field.name | translate }}
                                    <i
                                        *ngIf="field.tooltip"
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                        [matTooltip]="field.tooltip"
                                        matTooltipPosition="right"
                                    ></i>
                                </mat-label>
                                <mat-slide-toggle
                                    color="primary"
                                    [disabled]="field.readonly"
                                    (change)="field.onChange($event, field); updateFieldVisibility()"
                                    [(ngModel)]="entity[field.property]"
                                ></mat-slide-toggle>
                            </div>

                            <div
                                class="padding-y-10"
                                [class]="field.cssClass"
                                *ngIf="
                                    field.type === FormFieldType.Button &&
                                    field.visible
                                "
                            >
                                <button
                                    mat-button
                                    color="primary"
                                    (click)="
                                        field.onClick(entity[field.property])
                                    "
                                    class="button date-name"
                                    [disabled]="field.readonly"
                                >
                                    <span *ngIf="field.iconClass">
                                        <i
                                            [ngClass]="field.iconClass"
                                            class="icon"
                                        ></i>
                                    </span>
                                    {{ field.name | translate }}
                                </button>
                            </div>

                            <mat-form-field
                                *ngIf="
                                    field.type === FormFieldType.Number &&
                                    field.visible
                                "
                            >
                                <mat-label class="field-label">
                                    {{ field.name | translate }}
                                    {{ field.additionalLabelText }}
                                    <i
                                        *ngIf="field.tooltip"
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                        [matTooltip]="field.tooltip"
                                        matTooltipPosition="right"
                                    ></i>
                                </mat-label>
                                <input
                                    matInput
                                    type="number"
                                    [required]="field.required"
                                    [readonly]="field.readonly"
                                    (input)="field.onChange($event, field); updateFieldVisibility()"
                                    (blur)="onFieldBlur(field)"
                                    [(ngModel)]="entity[field.property]"
                                    [min]="field.numericMin"
                                    [max]="field.numericMax"
                                    [placeholder]="field.tooltip"
                                    (keypress)="
                                        onKeyPressValidateInput(
                                            $event,
                                            field.displayFormat,
                                            field.numericMin
                                        )
                                    "
                                />
                                <!-- DASH-2676: show the field's custom validation message when present,
                                     otherwise fall back to the generic required message. -->
                                <mat-error *ngIf="getFieldError(field) as fieldError">{{
                                    fieldError | translate
                                }}</mat-error>
                                <mat-error *ngIf="!getFieldError(field)"
                                    >{{ field.name | translate }}
                                    {{ "is required" | translate }}</mat-error
                                >
                            </mat-form-field>

                            <mat-form-field
                                *ngIf="
                                    field.type === FormFieldType.Time &&
                                    field.visible
                                "
                            >
                                <mat-label class="field-label">
                                    {{ field.name | translate }}
                                    <i
                                        *ngIf="field.tooltip"
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                        [matTooltip]="field.tooltip"
                                        matTooltipPosition="right"
                                    ></i>
                                </mat-label>
                                <input
                                    matInput
                                    [required]="field.required"
                                    [disabled]="field.readonly"
                                    class="time-input"
                                    [(ngModel)]="entity[field.property]"
                                    [placeholder]="field.tooltip"
                                    (ngModelChange)="
                                        onTimeChange($event, field)
                                    "
                                    [ngxMatTimepicker]="timePicker"
                                    [format]="'' | hour12Flag"
                                    [readonly]="field.readonly"
                                />
                                <ngx-mat-timepicker-toggle
                                    matSuffix
                                    [for]="timePicker"
                                ></ngx-mat-timepicker-toggle>
                                <ngx-mat-timepicker
                                    #timePicker
                                    appendToInput="true"
                                ></ngx-mat-timepicker>
                                <mat-error
                                    >{{ field.name | translate }}
                                    {{ "is required" | translate }}</mat-error
                                >
                                <span
                                    *ngIf="timeError && entity[field.property]"
                                >
                                    <mat-error>{{ timeError }}</mat-error>
                                </span>
                            </mat-form-field>

                            <div
                                class="container"
                                [ngClass]="field.cssClass"
                                *ngIf="
                                    field.type === FormFieldType.Date &&
                                    field.visible
                                "
                            >
                                <mat-form-field class="row">
                                    <mat-label class="field-label">
                                        {{ field.name | translate }}
                                        <i
                                            *ngIf="field.tooltip"
                                            class="fa fa-info-circle"
                                            aria-hidden="true"
                                            [matTooltip]="field.tooltip"
                                            matTooltipPosition="right"
                                        ></i>
                                    </mat-label>
                                    <input
                                        matInput
                                        [required]="field.required"
                                        [readonly]="field.readonly"
                                        [class]="field.cssClass"
                                        [(ngModel)]="entity[field.property]"
                                        [min]="$safeNavigationMigration(field?.min)"
                                        [max]="$safeNavigationMigration(field?.max)"
                                        [value]="entity[field.property]"
                                        [matDatepicker]="picker"
                                        [placeholder]="field.tooltip"
                                        [disabled]="field.readonly"
                                        (ngModelChange)="
                                            field.onChange($event, field); updateFieldVisibility()
                                        "
                                    />
                                    <mat-datepicker-toggle
                                        matIconSuffix
                                        [for]="picker"
                                    ></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                    <mat-error
                                        >{{ field.name | translate }}
                                        {{
                                            "is required" | translate
                                        }}</mat-error
                                    >
                                </mat-form-field>
                            </div>

                            <div
                                class="container"
                                [ngClass]="field.cssClass"
                                *ngIf="
                                    field.type === FormFieldType.DateTime &&
                                    field.visible
                                "
                            >
                                <mat-form-field class="row">
                                    <mat-label class="field-label">
                                        {{ field.name | translate }}
                                        <i
                                            *ngIf="field.tooltip"
                                            class="fa fa-info-circle"
                                            aria-hidden="true"
                                            [matTooltip]="field.tooltip"
                                            matTooltipPosition="right"
                                        ></i>
                                    </mat-label>
                                    <input
                                        matInput
                                        [required]="field.required"
                                        [class]="field.cssClass"
                                        [(ngModel)]="entity[field.property]"
                                        [min]="$safeNavigationMigration(field?.min)"
                                        [max]="$safeNavigationMigration(field?.max)"
                                        [owlDateTimeTrigger]="dtPicker"
                                        [owlDateTime]="dtPicker"
                                        [placeholder]="field.tooltip"
                                        [disabled]="field.readonly"
                                        (ngModelChange)="
                                            field.onChange($event, field); updateFieldVisibility()
                                        "
                                    />
                                    <owl-date-time
                                        #dtPicker
                                        [panelClass]="'form-owl-date-picker'"
                                        [hour12Timer]="('' | hour12Flag) === 12"
                                    >
                                    </owl-date-time>
                                    <mat-error
                                        >{{ field.name | translate }}
                                        {{
                                            "is required" | translate
                                        }}</mat-error
                                    >
                                </mat-form-field>
                            </div>

                            <div
                                class="container"
                                [ngClass]="field.cssClass"
                                *ngIf="
                                    field.type ===
                                        FormFieldType.FileAttachments &&
                                    field.visible
                                "
                            >
                                <div class="row">
                                    <a
                                        class="add-attachment"
                                        (click)="field.onClick(0)"
                                        >{{ field.additionalLabelText }}
                                    </a>
                                    <div
                                        *ngFor="let attachment of field.options; trackBy: trackByEntityId"
                                        class="attachment-item"
                                    >
                                        <span
                                            >{{ attachment.name }}
                                            {{ attachment.description }}</span
                                        >
                                        <button
                                            mat-icon-button
                                            color="warn"
                                            (click)="
                                                field.onClick(attachment.id)
                                            "
                                        >
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div
                                *ngIf="
                                    field.type === FormFieldType.Array &&
                                    field.visible
                                "
                                [class]="field.cssClass"
                            >
                                <div
                                    *ngFor="
                                        let item of field.items;
                                        let i = index;
                                        trackBy: trackByIndex
                                    "
                                    class="array-row"
                                >
                                    <div
                                        *ngFor="
                                            let fieldItem of item;
                                            let j = index;
                                            trackBy: trackByIndex
                                        "
                                        [class]="fieldItem.itemCssClass"
                                    >
                                        <div
                                            [ngClass]="fieldItem.cssClass"
                                            [class.disabled-div]="
                                                fieldItem.readonly
                                            "
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.Button &&
                                                fieldItem.rowVisibility?.[i]
                                            "
                                        >
                                            <button
                                                mat-button
                                                (click)="
                                                    fieldItem.onClick(
                                                        entity[field.property][
                                                            i
                                                        ]
                                                    )
                                                "
                                                class="button"
                                                [disabled]="fieldItem.readonly"
                                            >
                                                <span
                                                    *ngIf="fieldItem.iconClass"
                                                >
                                                    <i
                                                        [ngClass]="
                                                            fieldItem.iconClass
                                                        "
                                                        class="icon"
                                                    ></i>
                                                </span>
                                                {{ fieldItem.name | translate }}
                                            </button>
                                        </div>

                                        <div>
                                            <mat-form-field
                                                class="row"
                                                [class]="field.cssClass"
                                                *ngIf="
                                                    fieldItem.type ===
                                                        FormFieldType.Text &&
                                                    fieldItem.rowVisibility?.[i]
                                                "
                                            >
                                                <mat-label class="field-label">
                                                    {{
                                                        fieldItem.name
                                                            | translate
                                                    }}
                                                    <i
                                                        *ngIf="
                                                            fieldItem.tooltip
                                                        "
                                                        class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        [matTooltip]="
                                                            fieldItem.tooltip
                                                        "
                                                        matTooltipPosition="right"
                                                    ></i>
                                                </mat-label>
                                                <input
                                                    matInput
                                                    type="text"
                                                    [(ngModel)]="
                                                        entity[field.property][
                                                            i
                                                        ][fieldItem.property]
                                                    "
                                                    [readonly]="fieldItem.readonly"
                                                    [placeholder]="
                                                        fieldItem.tooltip
                                                    "
                                                    [required]="
                                                        fieldItem.isRequired
                                                    "
                                                    [class.cursor-not-allowed]="
                                                        fieldItem.readonly
                                                    "
                                                />
                                                <mat-error
                                                    *ngIf="
                                                        fieldItem.isRequired
                                                    "
                                                >
                                                    {{
                                                        fieldItem.name
                                                            | translate
                                                    }}
                                                    {{
                                                        "is required"
                                                            | translate
                                                    }}</mat-error
                                                >
                                            </mat-form-field>
                                        </div>

                                        <div
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.Toggle &&
                                                fieldItem.visible
                                            "
                                            [class]="fieldItem.cssClass"
                                        >
                                            <mat-label class="field-label mr-3">
                                                {{ fieldItem.name | translate }}
                                                <i
                                                    *ngIf="fieldItem.tooltip"
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="
                                                        fieldItem.tooltip
                                                    "
                                                    matTooltipPosition="right"
                                                ></i>
                                            </mat-label>
                                            <mat-slide-toggle
                                                color="primary"
                                                [disabled]="fieldItem.readonly"
                                                (change)="
                                                    fieldItem.onChange(
                                                        $event,
                                                        field,
                                                        i
                                                    ); updateFieldVisibility()
                                                "
                                                [(ngModel)]="
                                                    entity[field.property][i][
                                                        fieldItem.property
                                                    ]
                                                "
                                            ></mat-slide-toggle>
                                        </div>

                                        <div
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.Label &&
                                                fieldItem.visible
                                            "
                                            [class]="fieldItem.cssClass"
                                            (click)="
                                                fieldItem.onClick(
                                                    entity[field.property][i][
                                                        fieldItem.property
                                                    ]
                                                )
                                            "
                                        >
                                            <span *ngIf="fieldItem.iconClass">
                                                <i
                                                    [ngClass]="
                                                        fieldItem.iconClass
                                                    "
                                                    class="icon"
                                                ></i>
                                            </span>
                                            <mat-label class="field-label mr-3">
                                                {{ fieldItem.name | translate }}
                                                <i
                                                    *ngIf="fieldItem.tooltip"
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="
                                                        fieldItem.tooltip
                                                    "
                                                    matTooltipPosition="right"
                                                ></i>
                                            </mat-label>
                                        </div>

                                        <div
                                            [class.disabled-div]="
                                                fieldItem.readonly
                                            "
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.Number &&
                                                fieldItem.rowVisibility?.[i]
                                            "
                                        >
                                            <mat-form-field>
                                                <mat-label class="field-label">
                                                    {{
                                                        fieldItem.name
                                                            | translate
                                                    }}
                                                    {{
                                                        fieldItem.additionalLabelText
                                                    }}
                                                    <i
                                                        *ngIf="
                                                            fieldItem.tooltip
                                                        "
                                                        class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        [matTooltip]="
                                                            fieldItem.tooltip
                                                        "
                                                        matTooltipPosition="right"
                                                    ></i>
                                                </mat-label>
                                                <input
                                                    matInput
                                                    type="number"
                                                    [min]="fieldItem.numericMin"
                                                    [readonly]="
                                                        fieldItem.readonly
                                                    "
                                                    [class.cursor-not-allowed]="
                                                        fieldItem.readonly
                                                    "
                                                    [required]="
                                                        fieldItem.isRequired
                                                    "
                                                    [readonly]="
                                                        fieldItem.readonly
                                                    "
                                                    (input)="
                                                        fieldItem.onChange(
                                                            $event,
                                                            field,
                                                            i
                                                        ); updateFieldVisibility()
                                                    "
                                                    [max]="fieldItem.numericMax"
                                                    [(ngModel)]="
                                                        entity[field.property][
                                                            i
                                                        ][fieldItem.property]
                                                    "
                                                    (keypress)="
                                                        onKeyPressValidateInput(
                                                            $event,
                                                            fieldItem.displayFormat,
                                                            fieldItem.numericMin
                                                        )
                                                    "
                                                    [placeholder]="
                                                        fieldItem.tooltip
                                                    "
                                                />
                                            </mat-form-field>
                                        </div>

                                        <div
                                            [class]="fieldItem.cssClass"
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.Time &&
                                                fieldItem.rowVisibility?.[i]
                                            "
                                        >
                                            <mat-form-field class="row">
                                                <mat-label class="field-label">
                                                    {{
                                                        fieldItem.name
                                                            | translate
                                                    }}
                                                    <i
                                                        *ngIf="
                                                            fieldItem.tooltip
                                                        "
                                                        class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        [matTooltip]="
                                                            fieldItem.tooltip
                                                        "
                                                        matTooltipPosition="right"
                                                    ></i>
                                                </mat-label>
                                                <input
                                                    matInput
                                                    [required]="
                                                        fieldItem.isRequired
                                                    "
                                                    class="time-input"
                                                    [disabled]="
                                                        fieldItem.readonly
                                                    "
                                                    [(ngModel)]="
                                                        entity[field.property][
                                                            i
                                                        ][fieldItem.property]
                                                    "
                                                    (ngModelChange)="
                                                        onTimeChange(
                                                            $event,
                                                            field,
                                                            fieldItem,
                                                            i
                                                        )
                                                    "
                                                    [ngxMatTimepicker]="
                                                        timePicker
                                                    "
                                                    [format]="'' | hour12Flag"
                                                    [readonly]="field.readonly"
                                                    [placeholder]="
                                                        fieldItem.tooltip
                                                    "
                                                />
                                                <ngx-mat-timepicker-toggle
                                                    matSuffix
                                                    [for]="timePicker"
                                                ></ngx-mat-timepicker-toggle>
                                                <ngx-mat-timepicker
                                                    #timePicker
                                                    appendToInput="true"
                                                ></ngx-mat-timepicker>
                                            </mat-form-field>
                                            <span
                                                *ngIf="
                                                    timeError &&
                                                    entity[field.property][i][
                                                        fieldItem.property
                                                    ]
                                                "
                                            >
                                                <mat-error>{{
                                                    timeError
                                                }}</mat-error>
                                            </span>
                                        </div>

                                        <div
                                            class="container"
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.Date &&
                                                fieldItem.visible
                                            "
                                            [class]="fieldItem.cssClass"
                                        >
                                            <mat-form-field class="row">
                                                <mat-label class="field-label">
                                                    {{
                                                        fieldItem.name
                                                            | translate
                                                    }}
                                                    <i
                                                        *ngIf="
                                                            fieldItem.tooltip
                                                        "
                                                        class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        [matTooltip]="
                                                            fieldItem.tooltip
                                                        "
                                                        matTooltipPosition="right"
                                                    ></i>
                                                </mat-label>
                                                <input
                                                    matInput
                                                    [required]="
                                                        fieldItem.isRequired
                                                    "
                                                    [readonly]="field.readonly"
                                                    [placeholder]="
                                                        fieldItem.tooltip
                                                    "
                                                    [(ngModel)]="
                                                        entity[field.property][
                                                            i
                                                        ][fieldItem?.property]
                                                    "
                                                    [min]="$safeNavigationMigration(fieldItem?.min)"
                                                    [max]="$safeNavigationMigration(fieldItem?.max)"
                                                    [value]="
                                                        entity &&
                                                        entity[
                                                            field.property
                                                        ] &&
                                                        entity[field.property][
                                                            i
                                                        ] &&
                                                        entity[field.property][
                                                            i
                                                        ][fieldItem?.property]
                                                    "
                                                    [matDatepicker]="picker"
                                                    [disabled]="field.readonly"
                                                    (ngModelChange)="
                                                        fieldItem.onChange(
                                                            $event,
                                                            field,
                                                            i
                                                        ); updateFieldVisibility()
                                                    "
                                                />
                                                <mat-datepicker-toggle
                                                    matIconSuffix
                                                    [for]="picker"
                                                ></mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #picker
                                                ></mat-datepicker>
                                                <mat-error
                                                    *ngIf="
                                                        fieldItem.isRequired
                                                    "
                                                >
                                                    {{
                                                        $safeNavigationMigration(fieldItem?.name)
                                                            | translate
                                                    }}
                                                    {{
                                                        "is required"
                                                            | translate
                                                    }}</mat-error
                                                >
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="container"
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.DateTime &&
                                                fieldItem.visible
                                            "
                                            [class]="fieldItem.cssClass"
                                        >
                                            <mat-form-field class="row">
                                                <mat-label class="field-label">
                                                    {{
                                                        fieldItem.name
                                                            | translate
                                                    }}
                                                    <i
                                                        *ngIf="
                                                            fieldItem.tooltip
                                                        "
                                                        class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        [matTooltip]="
                                                            fieldItem.tooltip
                                                        "
                                                        matTooltipPosition="right"
                                                    ></i>
                                                </mat-label>
                                                <input
                                                    matInput
                                                    [required]="
                                                        fieldItem.isRequired
                                                    "
                                                    [(ngModel)]="
                                                        entity[field.property][
                                                            i
                                                        ][fieldItem?.property]
                                                    "
                                                    [min]="$safeNavigationMigration(fieldItem?.min)"
                                                    [max]="$safeNavigationMigration(fieldItem?.max)"
                                                    [owlDateTimeTrigger]="
                                                        dtPicker
                                                    "
                                                    [owlDateTime]="dtPicker"
                                                    [disabled]="field.readonly"
                                                    [placeholder]="
                                                        fieldItem.tooltip
                                                    "
                                                    (ngModelChange)="
                                                        fieldItem.onChange(
                                                            $event,
                                                            field,
                                                            i
                                                        ); updateFieldVisibility()
                                                    "
                                                />
                                                <owl-date-time
                                                    #dtPicker
                                                    [panelClass]="'form-owl-date-picker'"
                                                    [hour12Timer]="
                                                        ('' | hour12Flag) === 12
                                                    "
                                                >
                                                </owl-date-time>
                                                <mat-error
                                                    *ngIf="
                                                        fieldItem.isRequired
                                                    "
                                                    >{{
                                                        $safeNavigationMigration(fieldItem?.name)
                                                            | translate
                                                    }}
                                                    {{
                                                        "is required"
                                                            | translate
                                                    }}</mat-error
                                                >
                                            </mat-form-field>
                                        </div>

                                        <div
                                            *ngIf="
                                                (fieldItem.type ===
                                                    FormFieldType.SingleSelection ||
                                                    fieldItem.type ===
                                                        FormFieldType.MultipleSelection) &&
                                                fieldItem.visible
                                            "
                                            [class]="fieldItem.cssClass"
                                        >
                                            <mat-form-field>
                                                <mat-label class="field-label">
                                                    {{
                                                        fieldItem.name
                                                            | translate
                                                    }}
                                                    <i
                                                        *ngIf="
                                                            fieldItem.tooltip
                                                        "
                                                        class="fa fa-info-circle"
                                                        aria-hidden="true"
                                                        [matTooltip]="
                                                            fieldItem.tooltip
                                                        "
                                                        matTooltipPosition="right"
                                                    ></i>
                                                </mat-label>
                                                <mat-select
                                                    (selectionChange)="
                                                        fieldItem.onChange(
                                                            $event,
                                                            fieldItem
                                                        ); updateFieldVisibility()
                                                    "
                                                    [(ngModel)]="
                                                        entity[field.property][
                                                            i
                                                        ][fieldItem.property]
                                                    "
                                                    [required]="
                                                        fieldItem.isRequired
                                                    "
                                                    [disabled]="
                                                        $safeNavigationMigration(fieldItem?.readonly)
                                                    "
                                                    [placeholder]="
                                                        fieldItem.tooltip
                                                    "
                                                    [class.cursor-not-allowed]="
                                                        fieldItem.readonly
                                                    "
                                                    [multiple]="
                                                        fieldItem.type ===
                                                        FormFieldType.MultipleSelection
                                                    "
                                                >
                                                    <mat-option>
                                                        <ngx-mat-select-search
                                                            [(ngModel)]="
                                                                entity[
                                                                    field
                                                                        .property
                                                                ][i][
                                                                    fieldItem
                                                                        .searchProperty
                                                                ]
                                                            "
                                                            placeholderLabel="{{
                                                                'Search'
                                                                    | translate
                                                            }}..."
                                                        ></ngx-mat-select-search>
                                                    </mat-option>

                                                    <ng-container
                                                        *ngIf="
                                                            fieldItem.groups &&
                                                                fieldItem.groups
                                                                    .length > 0;
                                                            else noGroups
                                                        "
                                                    >
                                                        <mat-optgroup
                                                            *ngFor="
                                                                let group of fieldItem.groups;
                                                                trackBy: trackByIndex
                                                            "
                                                            [label]="
                                                                group.groupName
                                                            "
                                                        >
                                                            <mat-option
                                                                *ngFor="
                                                                    let option of group.items
                                                                        | filter
                                                                            : entity[
                                                                                  field
                                                                                      .property
                                                                              ][
                                                                                  i
                                                                              ][
                                                                                  fieldItem
                                                                                      .searchProperty
                                                                              ];
                                                                    trackBy: trackByEntityId
                                                                "
                                                                [value]="
                                                                    option.id
                                                                "
                                                            >
                                                                {{
                                                                    option.name
                                                                        | translate
                                                                }}
                                                            </mat-option>
                                                            <mat-option
                                                                disabled
                                                                *ngIf="
                                                                    (
                                                                        group.items
                                                                        | filter
                                                                            : entity[
                                                                                  field
                                                                                      .property
                                                                              ][
                                                                                  i
                                                                              ][
                                                                                  fieldItem
                                                                                      .searchProperty
                                                                              ]
                                                                    ).length ===
                                                                    0
                                                                "
                                                            >
                                                                {{
                                                                    "No options found"
                                                                        | translate
                                                                }}
                                                            </mat-option>
                                                        </mat-optgroup>
                                                    </ng-container>

                                                    <ng-template #noGroups>
                                                        <mat-option
                                                            *ngFor="
                                                                let option of fieldItem.options
                                                                    | filter
                                                                        : entity[
                                                                              field
                                                                                  .property
                                                                          ][i][
                                                                              fieldItem
                                                                                  .searchProperty
                                                                          ];
                                                                trackBy: trackByEntityId
                                                            "
                                                            [value]="option.id"
                                                        >
                                                            {{
                                                                option.name
                                                                    | translate
                                                            }}
                                                        </mat-option>
                                                        <mat-option
                                                            disabled
                                                            *ngIf="
                                                                (
                                                                    fieldItem.options
                                                                    | filter
                                                                        : entity[
                                                                              field
                                                                                  .property
                                                                          ][i][
                                                                              fieldItem
                                                                                  .searchProperty
                                                                          ]
                                                                ).length === 0
                                                            "
                                                        >
                                                            {{
                                                                "No options found"
                                                                    | translate
                                                            }}
                                                        </mat-option>
                                                    </ng-template>
                                                </mat-select>
                                                <button
                                                    class="selection-close-btn"
                                                    *ngIf="
                                                        entity[field.property][
                                                            i
                                                        ][
                                                            fieldItem.property
                                                        ] !== null &&
                                                        entity[field.property][
                                                            i
                                                        ][
                                                            fieldItem.property
                                                        ] !== undefined &&
                                                        fieldItem.type ===
                                                            FormFieldType.SingleSelection &&
                                                        !fieldItem?.readonly
                                                    "
                                                    mat-icon-button
                                                    matSuffix
                                                    tabindex="-1"
                                                    (click)="
                                                        clearArraySelect(
                                                            field,
                                                            fieldItem,
                                                            i
                                                        );
                                                        $event.stopPropagation()
                                                    "
                                                    [attr.aria-label]="
                                                        'Clear selection'
                                                            | translate
                                                    "
                                                >
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                                <mat-error
                                                    *ngIf="
                                                        fieldItem.isRequired
                                                    "
                                                    >{{
                                                        fieldItem.name
                                                            | translate
                                                    }}
                                                    {{
                                                        "is required"
                                                            | translate
                                                    }}</mat-error
                                                >
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="padding-y-10"
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.Checkbox &&
                                                fieldItem.visible
                                            "
                                        >
                                            <mat-checkbox
                                                color="primary"
                                                [(ngModel)]="
                                                    entity[field.property][i][
                                                        fieldItem.property
                                                    ]
                                                "
                                                (change)="
                                                    fieldItem.onChange($event); updateFieldVisibility()
                                                "
                                            >
                                                {{ fieldItem.name | translate }}
                                            </mat-checkbox>
                                        </div>

                                        <div
                                            class="padding-y-10"
                                            *ngIf="
                                                fieldItem.type ===
                                                    FormFieldType.Radio &&
                                                fieldItem.visible
                                            "
                                            [class]="fieldItem.cssClass"
                                        >
                                            <label
                                                class="field-label block mb-2"
                                                >{{
                                                    fieldItem.name | translate
                                                }}
                                                <i
                                                    *ngIf="fieldItem.tooltip"
                                                    class="fa fa-info-circle"
                                                    aria-hidden="true"
                                                    [matTooltip]="
                                                        fieldItem.tooltip
                                                    "
                                                    matTooltipPosition="right"
                                                ></i>
                                            </label>
                                            <mat-radio-group
                                                [(ngModel)]="
                                                    entity[field.property][i][
                                                        fieldItem.property
                                                    ]
                                                "
                                            >
                                                <mat-radio-button
                                                    *ngFor="
                                                        let option of fieldItem.options;
                                                        trackBy: trackByEntityId
                                                    "
                                                    [value]="option.id"
                                                    (change)="
                                                        fieldItem.onChange(
                                                            option.id,
                                                            field,
                                                            i
                                                        ); updateFieldVisibility()
                                                    "
                                                >
                                                    {{
                                                        option.name | translate
                                                    }}
                                                </mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div mat-dialog-actions class="createButton mt-2">
                    <ng-container *ngIf="!isReadonly">
                        <button
                            class="btn modal-footer-btn save-modal-btn"
                            (click)="mainButtonClick()"
                            [class.cursor-not-allowed]="isLoading"
                            [disabled]="cachedDisabled"
                        >
                            {{ mainButtonText }}
                        </button>
                    </ng-container>

                    <div class="createButton mt-3">
                        <button
                            class="btn modal-footer-btn cancel-modal-btn"
                            (click)="close()"
                        >
                            {{ closeButtonText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
